<template lang="pug">
  #MemberSearchIndex
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 顧客查詢
    .container-width
      .p-3
        b-form-group.mb-2.text-gray(
          label="顧客全名"
        )
          b-input-group
            b-form-input.border-0(
              v-model="searchInput.chinese_last_name",
              style="border-radius: 20px;background-color: #eee;"
            )
        b-form-group.mb-2.text-gray(
          label="LINE暱稱"
        )
          b-input-group
            b-form-input.border-0(
              v-model="searchInput.line_display_name",
              style="border-radius: 20px;background-color: #eee;"
            )
        b-form-group.mb-2.text-gray(
          label="顧客備註名"
        )
          b-input-group
            b-form-input.border-0(
              v-model="searchInput.note_name",
              style="border-radius: 20px;background-color: #eee;"
            )
        b-form-group.mb-2.text-gray(
          label="會員卡號"
        )
          b-input-group
            b-form-input.border-0(
              v-model="searchInput.code",
              style="border-radius: 20px;background-color: #eee;"
            )
        b-form-group.mb-2.text-gray(
          label="手機號碼"
        )
          b-input-group
            b-form-input.border-0(
              v-model="searchInput.mobile",
              style="border-radius: 20px;background-color: #eee;"
            )
        b-form-group.mb-3.text-gray(
          label="會員會籍"
        )
          b-form-select.border-0(
            id="card_type",
            required,
            v-model="searchInput.card_type",
            style="border-radius: 20px;background-color: #eee;"
          )
            template(
              v-slot:first
            )
              b-form-select-option(
                :value="null",
                disabled
              ) 請選擇會籍
            b-form-select-option(
              v-for="(level,index) in memberLevelList",
              :key="`${level}_${index}`",
              :value="level.role"
            ) {{ level.name }}
                                                            
        b-form-group.mb-3.text-gray(
          label="點數到期"
        )
          b-form-select.border-0(
            id="expire_point_month_type",
            required,
            v-model="searchInput.expire_point_month_type",
            style="border-radius: 20px;background-color: #eee;"
          )
            template(
              v-slot:first
            )
              b-form-select-option(
                :value="null",
                disabled
              ) 請選擇點數到期月份
              b-form-select-option(key="current", value="current") 本月
              b-form-select-option(key="next", value="next") 下月
              b-form-select-option(key="next2", value="next2") 下下月

        //- b-form-group.mb-3.text-gray(
        //-   label="14天內新客名單"
        //- )
        //-   b-form-select.border-0(
        //-     id="first_purchase_members",
        //-     required,
        //-     v-model="searchInput.first_purchase_members",
        //-     style="border-radius: 20px;background-color: #eee;"
        //-   )
        //-     template(
        //-       v-slot:first
        //-     )
        //-       b-form-select-option(
        //-         :value="null",
        //-       ) 全部
        //-       b-form-select-option(key="y", value="y") 符合
        //-       b-form-select-option(key="n", value="n") 不符合
            
        b-form-group.mb-3.text-gray(
          label="參與新客試用計畫"
        )
          b-form-select.border-0(
            id="join_new_customer_subscription",
            required,
            v-model="searchInput.join_new_customer_subscription",
            style="border-radius: 20px;background-color: #eee;"
          )
            template(
              v-slot:first
            )
            b-form-select-option(
              v-for="(option, index) in subscriptionList",
              :key="index",
              :value="option.value"
            ) {{ option.name }}
        b-form-group.mb-3.text-gray(
          label="符合新客資格"
        )
          b-form-select.border-0(
            id="match_new_customer_member",
            required,
            v-model="searchInput.match_new_customer_member",
            style="border-radius: 20px;background-color: #eee;"
          )
            template(
              v-slot:first
            )
            b-form-select-option(
              v-for="(option, index) in matchList",
              :key="index",
              :value="option.value"
            ) {{ option.name }}
        b-form-group.mb-3.text-gray(
          label="綁定美容顧問時間"
        )
          .d-flex.align-items-center
            b-input(
              v-model="searchInput.latest_binding_date_start"
              type="date",
              placeholder="開始區間",
              style="flex: 2!important;border-radius: 20px;background-color: #eee;width: calc(100%/3);"
            )
            p.mb-0.text-center(
              style="flex-grow: 0.5!important;"
            ) -
            b-input(
              v-model="searchInput.latest_binding_date_end"
              type="date",
              placeholder="結束區間",
              style="flex: 2!important;border-radius: 20px;background-color: #eee;width: calc(100%/3);"
            )   

        b-form-group.mb-3.text-gray(
          label="會員生日"
        )
          .d-flex.align-items-center
            b-form-select.border-0(
              v-model="searchInput.birthdayMonth",
              style="border-radius: 20px;background-color: #eee;"
            )
              template(
                v-slot:first
              )
                b-form-select-option(
                  :value="null",
                  disabled
                ) 請選擇月份
              b-form-select-option(
                v-for="index in 12",
                :value="index"
              ) {{ index }}
            span.px-2 月
            b-form-select.border-0(
              v-model="searchInput.birthdayDate",
              style="border-radius: 20px;background-color: #eee;"
            )
              template(
                v-slot:first
              )
                b-form-select-option(
                  :value="null",
                  disabled
                ) 請選擇日期
              b-form-select-option(
                v-for="index in 31",
                :value="index"
              ) {{ index }}
            span.px-2 日
        .row.no-gutters.justify-content-center
          .col-5.pl-1
            b-button.font-weight-bold.btn-custom(
              variant="primary",
              block,
              @click="searchHandler()",
              style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
            ) 搜尋
</template>

<script>
import { mapState } from "vuex";
import ProfilePhotoSticker from "@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue";
import { SA_GROUP_PUSH_INDEX } from "@/router/sa/group-push";

export default {
  name: "MemberSearchIndex",
  components: {
    ProfilePhotoSticker,
  },
  data() {
    return {
      searchInput: {
        chinese_last_name: null,
        line_display_name: null,
        note_name: null,
        code: null,
        card_type: null,
        expire_point_month_type: null,
        first_purchase_members: null,
        latest_binding_date_start: null,
        latest_binding_date_end: null,
        birthdayMonth: null,
        birthdayDate: null,
        mobile: null,
        join_new_customer_subscription: null,
        match_new_customer_member: null,
      },
      selectMode: false,
      selectUsers: [],
      infiniteId: +new Date(),
      subscriptionList: [
        { value: "null", name: "全部" },
        { value: "y", name: "已參與" },
        { value: "n", name: "未參與" },
      ],
      matchList: [
        { value: "null", name: "全部" },
        { value: "y", name: "符合新客" },
        { value: "n", name: "不符合新客" },
      ],
    };
  },
  created() {
    const vm = this;
    vm.$store.commit("toggleLoading", false);
    vm.$store.commit("sa_member_search/resetHandler");
    vm.$swal.fire({
      title: "載入中，請稍候",
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      },
    });
    vm.$store.dispatch("sa_member_search/getMemberLevelListHandler").then(() => {
      vm.$swal.close();
    });
    vm.$store.dispatch("sa_member_search/getMemberListHandler").then(() => {
      vm.$swal.close();
    });
  },
  methods: {
    infiniteHandler() {
      const vm = this;
      vm.$swal.fire({
        title: "搜尋中，請稍候",
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      let apiData = {
        chinese_last_name: vm.searchInput.chinese_last_name,
        line_display_name: vm.searchInput.line_display_name,
        note_name: vm.searchInput.note_name,
        code: vm.searchInput.code,
        card_type: vm.searchInput.card_type,
        expire_point_month_type: vm.searchInput.expire_point_month_type,
        first_purchase_members: vm.searchInput.first_purchase_members,
        latest_binding_date_start: vm.searchInput.latest_binding_date_start,
        latest_binding_date_end: vm.searchInput.latest_binding_date_end,
        birthday: vm.searchInput.birthdayMonth
          ? vm.searchInput.birthdayDate
            ? `${vm.searchInput.birthdayMonth
                .toString()
                .padStart(2, "0")}-${vm.searchInput.birthdayDate
                .toString()
                .padStart(2, "0")}`
            : `${vm.searchInput.birthdayMonth.toString().padStart(2, "0")}`
          : null,
        mobile: vm.searchInput.mobile,
        join_new_customer_subscription: vm.searchInput.join_new_customer_subscription,
        match_new_customer_member: vm.searchInput.match_new_customer_member,
        per_page: 999999,
      };
      vm.$store.dispatch("sa_member_search/getMemberListHandler", apiData).then((res) => {
        vm.$swal.close();
        vm.$store.commit("sa_group_push/setMemberList", res.data.members);
        const searchNameMap = {
          current: "本月",
          next: "下月",
          next2: "下下月",
        };
        const searchNameValue =
          searchNameMap[vm.searchInput.expire_point_month_type] || null;
        const routeParams = searchNameValue
          ? { params: { searchName: "點數到期-" + searchNameValue } }
          : { params: { searchName: "群發訊息" } };
        vm.$router.push({
          name: SA_GROUP_PUSH_INDEX,
          ...routeParams,
        });
      });
    },
    searchHandler() {
      const vm = this;
      if (!vm.searchInput.birthdayMonth && vm.searchInput.birthdayDate) {
        vm.$swal.fire({
          icon: "error",
          title: "會員生日尚未選擇月份",
        });
        return;
      }
      if (vm.searchInput.mobile) {
        let MobileReg = /^09\d{8}$/;
        if (!MobileReg.test(vm.searchInput.mobile)) {
          vm.$swal.fire({
            icon: "error",
            title: "手機號碼格式有誤",
          });
          return;
        }
      }
      vm.$store.commit("sa_member_search/resetHandler");
      vm.infiniteHandler();
    },
  },
  computed: {
    ...mapState({
      memberList: (state) => state.sa_member_search.memberList,
      cardTypeOptions: (state) => state.sa_member_search.cardTypeOptions,
      memberLevelList: (state) => state.sa_member_search.memberLevelList,
    }),
  },
};
</script>

<style lang="scss" scoped>
.searchArea {
  &__iconArrow {
    position: absolute;
    right: 10px;
    top: 5px;
    outline: none;
    transform: rotate(0deg);
    transition: all 0.3s;
  }
  &__iconArrow.collapsed {
    transform: rotate(180deg);
  }
}

.ProfilePhotoSticker {
  border: 0.2rem solid #000 !important;
}
</style>
